// react hook to scroll to a specific element
// Usage:
// const { scrollTo, scrollToRef } = useScrollTo();
// <div ref={scrollToRef}>Scroll to me</div>
// <button onClick={scrollTo}>Scroll</button>

import { useRef, useCallback } from 'react'

export const useScrollTo = () => {
  const ref = useRef<HTMLDivElement>(null)

  const scrollTo = useCallback(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }, [ref])

  return { scrollTo, scrollToRef: ref }
}